module.exports = __webpack_public_path__ + "img/gongjian.prt.7f2aaf80.jpg";